<template>
  <b-row>
    <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />
    <b-col lg="12" v-for="item in contents" :key="item.title">
      


      
      <b-card :title="item.title">
        <b-table
          :stacked="$mobile == 1"
          responsive="sm"
          :items="item.items"
          :fields="userfields"
        >

       
          <template #cell(activities)="data">
            <b-modal
            :id="'modal-center-'+data.item.id"
            title="الأنشطة"
            size="lg"
          >
            <b-row>
              <b-col lg="12">
                <b-table
                  :stacked="$mobile == 1"
                  responsive="sm"
                  :items="activities.filter((a) => a.edu_course_id == data.item.id)"
                  :fields="['الأسم', 'الدرجة']"
                >
                  <template #cell(الأسم)="data">
                    {{ data.item.name }}
                  </template>
                  <template #cell(الدرجة)="data">
                    <!-- {{ data.item.edu_course_id }} -->
                    {{ data.item.grade }} / {{ data.item.bestGrade }}
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-modal>
            <button v-b-modal="'modal-center-'+data.item.id" class="btn btn-primary">عرض الأنشطة</button>
          </template>
        </b-table>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import EduProgramsController from "@/Controllers/EduProgramsController";
import ActivitiesController from "@/Controllers/ActivitiesController";
import SemesterController from "@/Controllers/SemesterController";
import Auth from "@/Apis/Auth";
export default {
  data() {
    return {
      contents: [],
      text: "",
      textCh: "",
      load: false,
      activities: [],
      programCourses: [],
      failedProgramCourses : [],
      eduProgram: {},
      userfields: [
        {
          key: "code",
          label: this.$i18n.t("edu_courses.code"),
          sortable: true,
        },
        {
          key: "name",
          label: this.$i18n.t("edu_courses.name"),
          sortable: true,
        },
        {
          key: "activities",
          label: "الأنشطة",
          sortable: false,
        },
        // {
        //   key: "ch",
        //   label: "CH",
        //   sortable: true,
        // },
      ],
    };
  },
  async created() {
    this.load = true;
    var id = localStorage.getItem("eduProgram");
    if (!id) {
      id = this.$route.params.eduProgramId;
    }
    let res = await new EduProgramsController().getCourseByProgram(
      id,
      true
    );
    let semester = await new SemesterController().GetAll({
      filter: "edu_program_id|" + id,
    });
    this.programCourses = res.courses;
    semester.forEach((element) => {
      let programCoursesData = this.programCourses.filter(
        (a) => a.pivot.semester == element.id && a.flixable == 0
      );
      this.contents.push({
        title: element.name,
        items: programCoursesData,
      });
    });
    this.selectedContentIds = this.programCourses.map((a) => a.id);
    //get edu_courses_ids from failed_rooms_users where user_id = auth.user.id
    let edu_courses_of_failed_rooms_users = await new EduProgramsController().getEduCoursesOfFailedRoomsUsers(
      Auth.USER.id
    );
    this.failedProgramCourses = edu_courses_of_failed_rooms_users;
    const data = await new ActivitiesController().getStudentActivities({
      edu_course_ids: this.selectedContentIds,
      types: ["forum", "homework", "short_search", "exam"],
      with: ["questions", "user"],
    });
    data.activities.forEach((activity) => {
      const questions_ids = activity.questions.map((question) => question.id);
      const activity_answers = data.user_answers.filter((element) => {
        return questions_ids.includes(element.activity_question_id);
      });
      activity.bestGrade = this.best_grade(activity.grade, activity_answers);
    });
    this.activities = data.activities;

    this.load = false;
  },
  methods: {
    best_grade(activity_grade, answers) {
      //console.log(answers);
      //console.log(activity_grade);
      let grades = [];
      for (let i = 1; i <= 3; i++) {
        let correct_flag = 0;
        let mygrade = 0;
        const results = answers.filter((element) => {
          return element.answer_number == i;
        });
        if (results.length > 0) {
          results.map((el) => {
            if (el.grade != null) {
              correct_flag = 1;
              mygrade += el.grade;
            }
          });
          //console.log(mygrade);
          grades.push(
            correct_flag == 0
              ? null
              : ((mygrade / results.length) * (activity_grade / 100)).toFixed(2)
          );
        }
      }
      if (grades.every((element) => element === null)) {
        return "-";
      }
      console.log(grades);
      return Math.max(...grades);
    },
  },
};
</script>

<style></style>